/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { SocketService } from '../services';

@Injectable()
export class SocketGuard {

    constructor(
        private socketService: SocketService
    ) {
    }

    /**
     * Connect to the bear to get socket data.
     * @returns boolean
     */
    public canActivate(): boolean {
        // TODO make connect return true or false

        this.socketService.connect();

        return true;
    }
}
